// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { CSSObject } from 'styled-components';

export interface TextAlignProps {
  textAlign?: 'left' | 'center' | 'right';
}

export function textAlign({ textAlign }: TextAlignProps) {
  const style: CSSObject = {};

  if (textAlign) {
    style.textAlign = textAlign;
  }

  return style;
}
